/**
 * List sort order carried in URLs as `?sortBy=<criteria index>&ascending=<true|false>`. File links from a list include it,
 * and the file view passes it back, so returning to the list keeps the order the user had.
 */
export interface SortQuery {
  sortIdx: number;
  ascending: boolean;
}

export function readSortQuery(search: string): SortQuery {
  const params = new URLSearchParams(search);
  const sortIdx = parseInt(params.get('sortBy') || '0', 10);
  return { sortIdx: Number.isFinite(sortIdx) ? sortIdx : 0, ascending: params.get('ascending') !== 'false' };
}

export function sortQueryString({ sortIdx, ascending }: SortQuery): string {
  return `?sortBy=${sortIdx}&ascending=${ascending}`;
}
